import { axios } from '.'
import { useQuery, useMutation, UseQueryOptions } from '@tanstack/react-query'

type getUserListParam = {
  loginId: string
  password: string
}
const signIn = async (data: getUserListParam) => await axios.unauth.post('signin', data).then((res) => res.data)
export const useSignIn = (options?: object) => useMutation({ mutationFn: signIn, ...options })

const getAtoken = async (refreshToken: string) =>
  await axios.unauth
    .get('token', {
      headers: {
        Authorization: refreshToken
      }
    })
    .then((res) => res.data)
export const useGetAtoken = (options?: object) => useMutation({ mutationFn: getAtoken, ...options })
